// Shared typography for rendered article bodies. Used by both the public
// <ArticleBody> renderer and the admin WYSIWYG editor so what an author edits
// looks exactly like the published page.
export const ARTICLE_PROSE = [
    'prose prose-neutral max-w-none',
    'prose-headings:font-heading prose-headings:tracking-tight prose-headings:text-foreground',
    'prose-h2:mt-12 prose-h2:mb-4 prose-h2:text-[1.4rem] prose-h2:font-bold',
    'prose-h3:mt-8 prose-h3:mb-3 prose-h3:text-lg prose-h3:font-semibold',
    'prose-p:text-[15px] prose-p:leading-[1.78] prose-p:text-foreground/80',
    'prose-li:my-1 prose-li:text-[15px] prose-li:text-foreground/80 prose-li:marker:text-primary',
    'prose-ul:my-5 prose-ol:my-5',
    'prose-strong:font-semibold prose-strong:text-foreground',
    'prose-a:font-medium prose-a:text-primary prose-a:underline-offset-4 hover:prose-a:text-primary/80',
    'prose-blockquote:my-7 prose-blockquote:rounded-r-lg prose-blockquote:border-l-2 prose-blockquote:border-l-primary prose-blockquote:bg-secondary/60 prose-blockquote:px-5 prose-blockquote:py-3 prose-blockquote:font-normal prose-blockquote:not-italic prose-blockquote:text-foreground/90',
    "[&_blockquote_p:first-of-type]:before:content-[''] [&_blockquote_p:last-of-type]:after:content-['']",
    'prose-table:text-sm prose-th:text-foreground prose-td:text-foreground/80',
    'prose-hr:border-border'
].join(' ')
